export default "/fonts/vendor/fontsource-roboto/files/roboto-latin-ext-400-italic.woff2?5ed4cf182892091e3b758ae0c7c98c63";